<template>
  <div>
  <a-row :gutter="24" v-show="showTable">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="12">
              <a-col :md="5" :lg="5" :xxl="8" :sm="24">
                <a-form-item label="UDI编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入UDI编码" v-model="queryParam.productDi"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="5" :lg="5" :xl="7" :sm="24">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品名称">
                  <a-input placeholder="请输入产品名称" v-model="queryParam.productName"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :md="5" :lg="5" :xl="7" :sm="24">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="规格型号">
                  <a-input placeholder="请输入规格型号" v-model="queryParam.specificationModel"></a-input>
                </a-form-model-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="5" :lg="5"  :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 5px" @click="searchReset">重置</a-button>
                </a-col>
              </span>
            </a-row>

          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator" style="margin-top: 5px">
        </div>
        <!-- table区域-begin -->
        <div>
          <a-table ref="table1" size="middle" bordered :rowKey="(record,index)=>{return index}"
                   :columns="columns" :dataSource="dataSource" :components="handleDrag(columns)"
                   :pagination="ipagination"  :scroll="{ x: true }"  :loading="loading"
                   :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,columnWidth:'30px'}"
                   @change="handleTableChange">
            <span slot="action" slot-scope="text, record">
              <a @click="getInfoDetail(record)">明细</a>
            </span>
            <template slot="createTime" slot-scope="createTime">
              <span>{{changetime(createTime)}}</span>
            </template>
            <template slot="specCodeSystem" slot-scope="specCodeSystem">
              <span v-if="specCodeSystem === '1'">MA(IDcode)</span>
              <span v-else-if="specCodeSystem === '2'">GS1</span>
              <span v-else-if="specCodeSystem === ''">MA(IDcode)</span>
            </template>
          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->
        <!-- <retail-out-modal ref="modalForm" @ok="modalFormOk" @close="modalFormClose"></retail-out-modal> -->
        <PIModel ref="modalDetail" @ok="modalFormOk" @close="modalFormClose"></PIModel>
        <PIreorcd ref="PIreorcdref" @ok="modalFormOk" @close="modalFormClose"></PIreorcd>
        <PIrecordModel ref="PIrecordModelref" @ok="modalFormOk" @close="modalFormClose" @myHandleCopyAdd="(item)=>{showExportModal=true;isAllExport=false;row=item}"></PIrecordModel>
        <bill-excel-iframe ref="billExcelIframe" @ok="modalFormOk" @close="modalFormClose"></bill-excel-iframe>
        
      </a-card>
    </a-col>

    <a-modal :visible="showExportModal" :footer="null" title="选择导出方式" @cancel="showExportModal = false">
      <div style="display: flex;justify-content: space-evenly;">
        <a-button type="primary" @click="exportFile('txt')">导出Txt</a-button>
        <a-button type="primary" @click="exportFile('excel')">导出Excel</a-button>
      </div>
    </a-modal>
    
  </a-row>
  <a-row :gutter="24" v-show="!showTable">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
      <!-- 点击明细打开页面 -->
      <PiInfo ref="piInfo" @ok="modalFormOk" @close="modalFormClose" @refresh-parent="refreshParent"></PiInfo>
      </a-card>
    </a-col>
  </a-row>
  
</div>
</template>

<!-- create ji sheng hua-->
<script>
import PIModel from './modules/PIModel'
import PiInfo from './modules/PiInfo'
import PIreorcd from './modules/PIreorcd'
import PIrecordModel from './modules/PIrecordModel'
// import BillDetail from './dialog/BillDetail'
import BillExcelIframe from '@/components/tools/BillExcelIframe'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { BillListMixin } from './mixins/BillListMixin'
import JEllipsis from '@/components/jeecg/JEllipsis'
import JDate from '@/components/jeecg/JDate'
import Vue from 'vue'
import { PIadmin } from '@/api/manage'
import { getNowFormatStr } from '@/utils/util'
import { printgetAll, productDidel } from '@api/api'

export default {
  name: 'RetailOutList',
  mixins: [JeecgListMixin, BillListMixin],
  components: {
    PIModel,
    PIreorcd,
    PIrecordModel,
    // BillDetail,
    BillExcelIframe,
    JEllipsis,
    JDate,
    PiInfo
},
  data() {
    return {
      showExportModal:false,
      isAllExport:false,
      row:{},
      showTable: true,
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '100', '200'],
      },
      // 查询条件
      queryParam: {
        page: 1,
        limit: 20,
        productDi: '',
        productDi: '',
        specificationModel:''
      },
      prefixNo: 'LSCK',
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      specList: [
        {
          // 包装规格
          label: '初级包装',
          value: '0',
        },
        {
          label: '一级包装',
          value: '1',
        },
        {
          label: '二级包装',
          value: '2',
        },
        {
          label: '三级包装',
          value: '3',
        },
        {
          label: '四级包装',
          value: '4',
        },
        {
          label: '五级包装',
          value: '5',
        },
        {
          label: '六级包装',
          value: '6',
        },
        {
          label: '七级包装',
          value: '7',
        },
        {
          label: '八级包装',
          value: '8',
        },
        {
          label: '九级包装',
          value: '9',
        },
      ],
      matype: [
        {
          label: 'MA码(IDcode)',
          value: '1',
        },
        {
          label: 'GS1',
          value: '2',
        }
      ], // 包装规格
      // 默认列
      columns: [
        { title: '产品编码-DI', dataIndex: 'productDi', width: 150, ellipsis: true },
        // { title: '编码类型', dataIndex: 'specCodeSystem', width: 80,scopedSlots: { customRender: 'specCodeSystem' } },
        {
          title: '产品名称',
          dataIndex: 'productName',
          width: 80,
        },
        { title: '规格型号', dataIndex: 'specificationModel', width: 80, ellipsis: true },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 80,
          ellipsis: true,
          scopedSlots: { customRender: 'createTime' },
        },
        { title: '最高包装级别', dataIndex: 'packageLevel', width: 80 },
        { title: '申报时间', dataIndex: 'createTime', width: 120 },
        { title: '生码数量', dataIndex: 'createCodeCount', width: 80 },
        
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/productPi/di/list',
        delete: '/depotHead/delete',
        deleteBatch: '/depotHead/deleteBatch',
        batchSetStatusUrl: '/depotHead/batchSetStatus',
      },
      ul: {
        haha: '/productPi/exportPiExcelByProductId',
        hahaTxt: '/productPi/exportPiTxtByPiId'
      }
    }
  },
  computed: {},
  created() {
    //printgetAll().then(res=>{
      //console.log(res)
      // res.data.forEach(data=>{
      //   data.datas.forEach(datas=>{
      //     let option = JSON.parse(datas.option)
      //     if(!option.options){
      //
      //     }
      //   })
      // })
    //})
    // this.initSystemConfig()
    this.initRetail()
    this.getDepotData()
    this.initUser()
    this.initAccount()
  },
  methods: {
    // 查询
    searchQuery(){
      this.loadData(this.queryParam)
    },
    myPIrecord(record) {
      this.$refs.PIrecordModelref.add(record)
    },
    refreshParent(){
      this.showTable = true
    },
    myHandleCopyAdd(fileName, res,isall) {
      const that = this
      this.$confirm({
        title: "导出",
        content: "请选择导出类型?",
        okText: "导出excel",
        cancelText: "导出txt",
        maskClosable: true,
        okButtonProps: {
          style: { backgroundColor: '#1890ff', borderColor: '#1890ff' }
        },
        cancelButtonProps: {
          style: { backgroundColor: '#1890ff', borderColor: '#1890ff',color:'#fff' }
        },
        onOk: function () {
          that.exportFile(fileName, res,'excel',isall)
        },
        onCancel:function(e,a,b){
          that.exportFile(fileName, res,'txt',isall)
        }
      })
      // this.$confirm('是否删除数据?', '导出', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //   }).then(() => {
      //     handler(...args)
      //   }).catch(() => {});
    },
    // 明细
    getInfoDetail(record){
      this.showTable = false
      this.$refs.piInfo.show(record)
    },
    handleDelete(record){
      this.$confirm('是否删除数据', '确认操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.deletePIInfo(record)
      }).catch(() => {});
    },
    async deletePIInfo(record){
      const res = await productDidel({id: record.productId})
      if( res.code === 200 && res.success === true ){
        this.$message({
          type: 'success',
          message: '删除成功'
        })
        this.loadData(this.queryParam)
      } else {
        this.$message({
          type: 'error',
          message: res.message
        })
      }
    },
    exportFile(type){
      let hehe = {
        productId: this.row.id,
        id: this.row.id,
        specificationId: this.row.specificationId
      }
      const fileName = '导出文件'
      let searchObj = {}
      searchObj.search = JSON.stringify(this.queryParam)
      searchObj.currentPage = this.ipagination.current
      searchObj.pageSize = this.ipagination.pageSize

      let url = ''
      if(type=='txt'){
        if(this.isAllExport){
          url = '/productPi/exportPiTxtByProductId'
        }else{
          url = '/productPi/exportPiTxtByPiId'
        }
      }else{
        if(this.isAllExport){
          url = '/productPi/exportPiExcelByProductId'
        }else{
          url = '/productPi/exportPiExcelByPiId'
        }
      }

      PIadmin(url, hehe).then((data) => {
        if (!data) {
          this.$message.warning("文件下载失败")
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          if(type == 'txt'){
            window.navigator.msSaveBlob(new Blob([data], { type: 'text/plain' }), fileName + '.txt')
          }else{
            window.navigator.msSaveBlob(new Blob([data], { type: 'application/vnd.ms-excel' }), fileName + '1.xls')
          }
        } else {
          let url = ''
          if(type == 'txt'){
            url = window.URL.createObjectURL(new Blob([data], { type: 'text/plain' }))
          }else{
            url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
          }
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', ( fileName + '_' + getNowFormatStr() + (type == 'txt'?'.txt':'.xls')))
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link) //下载完成移除元素
          window.URL.revokeObjectURL(url) //释放掉blob对象
        }
      })
    },

    changetime(createTime) {
      return createTime.replace('T', ' ')
    },
    myHandleDetailPI(record) {
      this.$refs.modalDetail.add(record)
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>